import {
  ChangeDetectionStrategy, Component, createNgModule, OnInit, ViewChild, ViewContainerRef,
  Injector,
  ComponentRef,
  Input, OnChanges, 
  
  
} from '@angular/core';



import type { CustomSearchBoxComponent as OriginalComponent } from 'ish-shared/dias/components/search/custom-search-box/custom-search-box.component';

@Component({
  selector: 'custom-lazy-search-box',
  standalone: false,
  templateUrl: './lazy-custom-search-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LazyCustomSearchBoxComponent implements OnInit , OnChanges {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component shared/dias/components/search/custom-search-box/custom-search-box.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;


  @Input() configuration: OriginalComponent['configuration'];


  private component: ComponentRef<OriginalComponent>;
  

  constructor(
    
    private injector: Injector
  ) {}

  async ngOnInit() {
    

      await this.renderComponent();

    
  }

  private async renderComponent() {
    const module = await import(`../../../shared/shared.module`).then(m => m.SharedModule);

    const { CustomSearchBoxComponent: originalComponent } = await import('ish-shared/dias/components/search/custom-search-box/custom-search-box.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });
  
    this.ngOnChanges(
      
    );
  
    this.component.changeDetectorRef.markForCheck();
  }


  ngOnChanges() {
    if (this.component) {
      
        this.component.instance.configuration = this.configuration;
      

      
    }
  }

}
